(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["variant-card-image-swatches"] && !Shopify.designMode) return;
  try {
    (() => {
    const roots = document.querySelectorAll('[data-card-variant-swatches-root]');

    roots.forEach((root) => {
      const trigger = root.querySelector('[data-card-variant-swatches-more-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        root.classList.add('card-variant-swatches--expanded');

        if (document.startViewTransition) {
          document.startViewTransition(() => {});
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
